import script from "./EmailVerificationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerificationForm.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerificationForm.vue?vue&type=style&index=0&id=93e962f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93e962f6"]])

export default __exports__